<template>
  <div class="container">
    <div class="title">
      大数据开发工程师
      <span>New</span>
    </div>
    <div class="content">
      <span>重庆</span>
      |
      <span>技术</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'joinItem'
}
</script>
<style scoped lang="less">
.container {
  padding: 20px 0 19px 22px;
  border: 0.5px solid #D8DCDF;
}
.title {
  font-size: 18px;
  span {
    display: inline-block;
    color: #FF4D00;
    margin-left: 8px;
  }
}
.content {
  font-size: 12px;
}
</style>